import { Component } from '@angular/core';

@Component({
  selector: 'app-assests-link',
  templateUrl: './assests-link.component.html',
  styleUrls: ['./assests-link.component.scss']
})
export class AssestsLinkComponent {

}
